// Fetch Students
export const FETCH_STUDENTS_REQUEST = 'ADMIN_FETCH_STUDENTS_REQUEST';
export const FETCH_STUDENTS_SUCCESS = 'ADMIN_FETCH_STUDENTS_SUCCESS';
export const FETCH_STUDENTS_FAILURE = 'ADMIN_FETCH_STUDENTS_FAILURE';

// Upload Students
export const UPLOAD_STUDENTS_REQUEST = 'ADMIN_UPLOAD_STUDENTS_REQUEST';
export const UPLOAD_STUDENTS_SUCCESS = 'ADMIN_UPLOAD_STUDENTS_SUCCESS';
export const UPLOAD_STUDENTS_FAILURE = 'ADMIN_UPLOAD_STUDENTS_FAILURE';

export const CLEAR_UPLOAD_RESULT = 'ADMIN_CLEAR_UPLOAD_RESULT';

// Update Student
export const UPDATE_STUDENT_REQUEST = 'ADMIN_UPDATE_STUDENT_REQUEST';
export const UPDATE_STUDENT_SUCCESS = 'ADMIN_UPDATE_STUDENT_SUCCESS';
export const UPDATE_STUDENT_FAILURE = 'ADMIN_UPDATE_STUDENT_FAILURE';